import { useCallback } from 'react'
import classNames from 'classnames'
import { Col, Row } from 'antd'
import { history, useRouteProps } from 'umi'
import { useStore } from '@/states/store';
import goToRoute from '@/utils/goToRoute'
import styles from './index.less'

type IMenu = {
  path: string
  logo: string
  name: string
}

interface IProps {
  menus: Array<Partial<IMenu>>
}
const Menu = (props: IProps) => {
  const { menus } = props
  const { userInfo } = useStore()
  const router = useRouteProps()

  const handleGoPath = useCallback((menu?: any) => {
    const { path, checkLogin, check,notNeedLogin } = menu || {}
    if(notNeedLogin){
      history.push({
        pathname:path,
      })
      return
    }
    if (path) {
      goToRoute(path, (path.includes('marketing-poster') && userInfo?.specialInfo?.g3 === 'A') ? undefined : check)
    }
  }, [])

  return (
    <div className={styles.toolsMenu}>
      <Row gutter={[10, 10]}>
        {menus.map(menu => {
          const { path, logo, name } = menu

          return (
            <Col key={path}>
              <div
                className={classNames([styles.menuItem, { [styles.active]: path === router.path }])}
                onClick={handleGoPath.bind(null, menu)}
              >
                <span className={classNames([`icon-${logo}`, styles.icon])} />
                <span className={styles.label}>{name}</span>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default Menu
